import { Backdrop, CircularProgress, LinearProgress, Stack, Typography } from '@mui/material'
import Admin from 'api/Admin'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SimpleTable from 'v2/SimpleTable'



const newData = {
  "purpose": "",
  "short_description": "",
  "purpose_queries": {},
  "firstname": "",
  "lastname": "",
  "gender": "",
  "dob": "",
  "phoneno": "",
  "email": null,
  "nationality": "",
  "religion": "",
  "marital_status": "",
  "highest_edu": "",
  "profession": "",
  "monthly_income": 0,
  "tot_fam_income": 0,
  "tot_dependants": 0,
  "cibil_score": 0,
  "covenants_risks": "",
  "request_amt": "300",
  "has_guarantor": 0,
  "guarantor_user_id": 0,
  "guarantor_name": "",
  "guarantor_phone": "",
  "guarantor_email": "",
  "coordinator_user_id": 0,
  "grant_type": "",
  "approval_status": "new",
  "disbursement_schedule": "",
  "collateral": "",
  "referred_by": "",
  "case_submit_date": "",
  "identity_proof": "",
  "address_proof": "",
  "income_proof": "",
  "profile_pic": "",
  "identity_proof_copy": "",
  "address_copy": "",
  "income_copy": "",
  "status": "active",
  "address": {
    "current_address": {
      "address_line1": "",
      "address_line2": "",
      "cur_town": "",
      "city": "",
      "district": "",
      "state": "",
      "country": "",
      "pincode": "",
      "address_type": "temporary",
      "period_of_stay": ""
    },
    "permanent_address": {
      "address_line1": "",
      "address_line2": "",
      "cur_town": "",
      "city": "",
      "district": "",
      "state": "",
      "country": "",
      "pincode": "",
      "address_type": "permanent",
      "period_of_stay": ""
    }
  },
  "default_shipping_flag": 1,
  "default_billing_flag": 1,
  "default_communication": 1,
  "coapplicant": {
    "coapplicant_user_id": 0,
    "firstname": "",
    "lastname": "",
    "gender": "",
    "dob": "",
    "phoneno": null,
    "email": null,
    "nationality": "",
    "religion": "",
    "marital_status": "",
    "highest_edu": "",
    "profession": "",
    "monthly_income": "0.00",
    "tot_fam_income": "0.00",
    "tot_dependants": "",
    "cibil_score": "",
    "covenants_risks": "No",
    "identity_proof": "",
    "address_proof": "",
    "income_proof": "",
    "profile_pic": null,
    "identity_proof_copy": "",
    "address_copy": "",
    "income_copy": "",
    "is_guarantor": false,
    "status": "active",
    "address": {
      "current_address": {
        "address_line1": "",
        "address_line2": "",
        "cur_town": "",
        "city": "",
        "district": "",
        "state": "",
        "country": "",
        "pincode": "",
        "address_type": "permanent",
        "period_of_stay": ""
      }
    },
    "default_shipping_flag": 1,
    "default_billing_flag": 1,
    "default_communication": 1
  }
}


const columns = [
  {
    label: "Name",
    name: "label"
  },
  {
    label: "Details",
    name: "details"
  }
]

const basic = [
  {
    label: "User name",
    name: "name"
  },
  {
    label: "ID",
    name: "id"
  },
  {
    label: "Mobile No.",
    name: "phoneno"
  },
  {
    label: "Email",
    name: "email"
  },
  {
    label: "Requested Grant Amount",
    name: "request_amt"
  },
]

const purpose = [
  {
    label: "Purpose",
    name: "purpose"
  },
  {
    label: "Description",
    name: "short_description"
  }
]

const loan = [
  { "name": "has_guarantor", "label": "Has Guarantor?" },
  { "name": "guarantor_name", "label": "Guarantor name:" },
  { "name": "guarantor_phone", "label": "Guarantor phone number:" },
  { "name": "guarantor_email", "label": "Guarantor email id:" },
  { "name": "request_amt", "label": "Requested Grant Amount (₹)" },
  { "name": "referred_by", "label": "Referred By:" },
  { "name": "grant_type", "label": "Grant Repayment" },
  { "name": "disbursement_schedule", "label": "Disbursement Schedule:" },
  { "name": "collateral", "label": "Collaterals or Securities to be provided against the grant:" }

]

const coapplicant = [
  {
    "name": "phoneno",
    "label": "Phone Number",

  },
  {
    "name": "email",
    "label": "Email",

  },
  {
    "name": "firstname",
    "label": "First Name",

  },
  {
    "name": "lastname",
    "label": "Last Name",

  },
  {
    "name": "gender",
    "label": "Gender",
    type: "select",
    "options": [
      { value: "", label: "Select One" },
      "Male",
      "Female",
      "Other"
    ]
  },
  {
    "name": "dob",
    "label": "Date of Birth",
    type: "date"
  },
  {
    "name": "nationality",
    "label": "Nationality",
    type: "select",
    options: [
      { value: "", label: "Select One" },
      "India",
      "United States",
      "China",
      "Japan",
      "Germany",
      "United Kingdom",
      "France",
      "Italy",
      "Brazil",
      "Canada"
    ]
  },
  {
    "name": "religion",
    "label": "Religion",
    type: "select",
    "options": [
      { value: "", label: "Select One" },
      "Hinduism",
      "Christianity",
      "Islam",
      "Buddhism",
      "Sikhism",
      "Judaism",
      "Bahá'í Faith",
      "Jainism",
      "Shinto",
      "Taoism",
      "Zoroastrianism",
      "Animism",
      "Confucianism",
      "Paganism",
      "Rastafarianism"
    ]
  },
  {
    "name": "marital_status",
    "label": "Marital Status",
    type: "select",
    "options": [
      { value: "", label: "Select One" },
      "Single",
      "Married",
      "Divorced",
      "Widowed"
    ]
  },
  {
    "name": "highest_edu",
    "label": "Highest Education",

  },
  {
    "name": "profession",
    "label": "Profession",

  },
  {
    "name": "monthly_income",
    "label": "Monthly Personal Income",

  },
  {
    "name": "tot_fam_income",
    "label": "Monthly Family Income",

  },
  {
    "name": "tot_dependants",
    "label": "No. of Dependents",

  },
  {
    "name": "cibil_score",
    "label": "CIBIL Score",

  },
  {
    "name": "is_guarantor",
    "label": "Guarantor",
    type: "select",
    "options": [
      { value: "", label: "Select One" },
      "No",
      "Yes"
    ]
  },
  {
    "name": "address.address_line1",
    "label": "Address Line 1",

  },
  {
    "name": "address.address_line2",
    "label": "Address Line 2",

  },
  {
    "name": "address.cur_town",
    "label": "Town/City",

  },
  {
    "name": "address.state",
    "label": "State",

  },
  {
    "name": "address.district",
    "label": "District",

  },
  {
    "name": "address.country",
    "label": "Country",

  },
  {
    "name": "address.pincode",
    "label": "Pincode",

  },
  {
    "name": "address.period_of_stay",
    "label": "Period of stay at the above address in years",

  },
  {
    "name": "address.address_type",
    "label": "Address Type",
    type: "select",
    "options": [
      { value: "", label: "Select One" },
      "Permanent",
      "Temporary"
    ]
  },
]


export default function Step5({ payload }) {

  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const body = Object.assign(newData, payload)


  const back = document.getElementById("back")
  const progress = document.getElementById("progress")
  const submit = document.getElementById("submit")

  const loadingState = (loading) => {
    // if (loading) {
    //   progress.style.display = "block"
    //   back.disabled = true
    //   submit.disabled = true
    // } else {
    //   back.disabled = false
    //   submit.disabled = false
    //   progress.style.display = "none"
    // }
  }

  const onClick = async () => {
    try {
      delete body.purpose_data
      loadingState(true)
      const res = await Admin.Case.create({ body })
      navigate('/')
    } catch (error) {
      alert(error.message)
    } finally {
      loadingState(false)
    }
  }


  useEffect(() => {
    const btn = document.getElementById("submit")
    btn.addEventListener("click", onClick)

    return () => {
      btn.removeEventListener("click", onClick)
    }
  }, [])


  const basicRows = basic.map(d => {
    let details = body[d.name]
    if (d.name == "name") {
      details = body.firstname + " " + body.lastname
    }
    if (!details) {
      details = <span style={{ fontStyle: "italic" }}>NA</span>
    }
    return { ...d, details }
  })

  const purposeRows = purpose.map(d => {
    const details = body[d.name]
    return { ...d, details }
  })

  if (body.purpose_queries.question_details?.length) {
    const f = body.purpose_queries.question_details.map(d => ({ label: d.question, details: d.answer }))
    purposeRows.push(...f)
  }

  const loanRow = loan.map(d => {
    let details = body[d.name]
    if (!details) {
      details = <span style={{ fontStyle: "italic" }}>NA</span>
    }
    return { ...d, details }
  })
  const coapplicantRow = coapplicant.map(d => {

    let details
    if (d.name.startsWith("address")) {
      details = body.coapplicant.address?.current_address?.[d.name.replace("address.", '')]
    } else {
      details = body["coapplicant"][d.name]
    }

    if (!details) {
      details = <span style={{ fontStyle: "italic" }}>NA</span>
    }
    return { ...d, details }
  })


  return (
    <div>
      <Typography>Basic Details</Typography>
      <SimpleTable columns={columns} data={basicRows} />
      <Typography>Purpose Details</Typography>
      <SimpleTable columns={columns} data={purposeRows} />
      <Typography>Loan Details</Typography>
      <SimpleTable columns={columns} data={loanRow} />
      <Typography>Co-applicant</Typography>
      <SimpleTable columns={columns} data={coapplicantRow} />
      <Typography textAlign={"center"}>End of details</Typography>
    </div>
  )
}
